"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * This "component" is only used to call its
 * `.listenToTouches()` and `.stopListeningToTouches()`
 * methods manually through a `ref`.
 */
var OnTapOutside = /*#__PURE__*/function (_React$Component) {
  _inherits(OnTapOutside, _React$Component);
  var _super = _createSuper(OnTapOutside);
  function OnTapOutside() {
    var _this;
    _classCallCheck(this, OnTapOutside);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (event) {
      // Ignore multitouch.
      if (event.touches.length > 1) {
        // Reset.
        return _this.onTouchCancel();
      }
      var touch = event.changedTouches[0];
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.touchId = touch.identifier;
      _this.tapping = true;
    });
    _defineProperty(_assertThisInitialized(_this), "onTouchMove", function (event) {
      var moveThreshold = _this.props.moveThreshold;
      if (!_this.tapping) {
        return;
      }
      var x;
      var y;
      for (var _iterator = _createForOfIteratorHelperLoose(event.changedTouches), _step; !(_step = _iterator()).done;) {
        var touch = _step.value;
        if (touch.identifier === _this.touchId) {
          x = touch.clientX;
          y = touch.clientY;
          break;
        }
      }

      // If not the touch.
      if (x === undefined) {
        return;
      }
      var deltaX = Math.abs(x - _this.initialTouchX);
      var deltaY = Math.abs(y - _this.initialTouchY);

      // Reset on touch move.
      if (deltaX > moveThreshold || deltaY > moveThreshold) {
        _this.onTouchCancel();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (event) {
      if (!_this.tapping) {
        return;
      }
      for (var _iterator2 = _createForOfIteratorHelperLoose(event.changedTouches), _step2; !(_step2 = _iterator2()).done;) {
        var touch = _step2.value;
        if (touch.identifier === _this.touchId) {
          // Reset.
          _this.onTouchCancel();
          // Handle the tap.
          // https://developer.mozilla.org/en-US/docs/Web/API/Touch
          _this.onTap(event, touch.target);
          break;
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onTouchCancel", function () {
      _this.initialTouchX = undefined;
      _this.initialTouchY = undefined;
      _this.touchId = undefined;
      _this.tapping = false;
    });
    // On mobile devices "blur" event isn't triggered
    // when a user taps outside. This is to allow touch scrolling
    // while not losing focus on an input field or a button.
    // Adding a manual "on click" listener to emulate
    // "on blur" event when user taps outside (to collapse the expandable).
    _defineProperty(_assertThisInitialized(_this), "onTap", function (event, target) {
      var _this$props = _this.props,
        getContainerNode = _this$props.getContainerNode,
        getTogglerNode = _this$props.getTogglerNode,
        onTapOutside = _this$props.onTapOutside;
      if (getContainerNode().contains(target)) {
        return;
      }
      if (getTogglerNode) {
        if (getTogglerNode().contains(target)) {
          return;
        }
      }
      if (onTapOutside) {
        _this.focusOut = true;
        onTapOutside(event);
        _this.focusOut = undefined;
      }
    });
    return _this;
  }
  _createClass(OnTapOutside, [{
    key: "listenToTouches",
    value: function listenToTouches() {
      document.addEventListener('touchstart', this.onTouchStart);
      document.addEventListener('touchmove', this.onTouchMove);
      document.addEventListener('touchend', this.onTouchEnd);
      document.addEventListener('touchcancel', this.onTouchCancel);
    }
  }, {
    key: "stopListeningToTouches",
    value: function stopListeningToTouches() {
      document.removeEventListener('touchstart', this.onTouchStart);
      document.removeEventListener('touchmove', this.onTouchMove);
      document.removeEventListener('touchend', this.onTouchEnd);
      document.removeEventListener('touchcancel', this.onTouchCancel);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningToTouches();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);
  return OnTapOutside;
}(_react["default"].Component);
exports["default"] = OnTapOutside;
_defineProperty(OnTapOutside, "propTypes", {
  onTapOutside: _propTypes["default"].func.isRequired,
  getTogglerNode: _propTypes["default"].func,
  getContainerNode: _propTypes["default"].func.isRequired,
  moveThreshold: _propTypes["default"].number
});
_defineProperty(OnTapOutside, "defaultProps", {
  moveThreshold: 5
});
//# sourceMappingURL=OnTapOutside.js.map